import React, { Component, useState } from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import { Button } from "@material-ui/core";
import Table from "../../../widgets/tables/Table";
import WaitDialog from "../../../widgets/WaitDialog";
import GetCorsi from "../../../services/getCorsi";
import getStudenti from "../../../services/getStudentiForBilling";
import GestioneRateWidget from "../../../widgets/GestioneRateWidget";
import getPianoPagamentiCorso from "../../../services/getPianoPagamentiCorso";
import addPianoPagamentiCorso from "../../../services/addPianoPagamentiCorso";
import getPianoPagamentiCorsoStudenti from "../../../services/getPianoPagamentiCorsoStudenti";
import getRataStatus from "../../../services/getRataStatus";
import AddRataWidget from "../../../widgets/AddRataWidget";
import GestioneRateCorsoWidget from "../../../widgets/GestioneRataCorsoWidget";
import UploadDocument from "../../../widgets/uploadDispense";
import UploadPdfPagamenti from "../../../widgets/uploadPdfPagamenti";
import getPdfPagamentiStatus from "../../../services/getPdfPagamentiStatus";
import deletePdfPagamenti from "../../../services/deletePdfPagamenti";

export default class EditCorso extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {
      showAddRata: false,
      uploadPdfShow: false,
      uploaded: false,
      pdfFileName: null,
    };
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    this.corsi = await GetCorsi(username, token);
    this.corso = this.corsi.find((c) => c.id == currentCourse);

    this.studenti = await getStudenti(username, token);
    this.studenti = this.studenti.filter((s) => {
      if (!s.corsi) return false;

      // Gestisce diversi formati: singolo ID, con virgola, con punto e virgola
      const corsiList = s.corsi
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      return corsiList.includes(currentCourse);
    });

    this.pdfPagamentiStatus = await getPdfPagamentiStatus(
      username,
      token,
      this.corso.id
    );

    console.log("pdfPagamentiStatus", this.pdfPagamentiStatus);
    console.log("Proprietà disponibili:", Object.keys(this.pdfPagamentiStatus));

    for (var i = 0; i < this.studenti.length; i++) {
      var s = this.studenti[i];
      if (s == undefined) continue;
      var pianoRateCorsoStudente = await getPianoPagamentiCorsoStudenti(
        username,
        token,
        this.corso.id,
        s.id
      );
      this.studenti[i].piano =
        pianoRateCorsoStudente != undefined && pianoRateCorsoStudente != null
          ? "OK"
          : "";
    }

    const pianoPagamentiCorso = await getPianoPagamentiCorso(
      username,
      token,
      this.corso.id
    );
    const costoCorso = parseInt(
      pianoPagamentiCorso != undefined ? pianoPagamentiCorso.costo : 0
    );
    this.costoTotale = 0;
    this.totalePagato = 0;

    this.costoStudente = [];
    for (var s of this.studenti) {
      const pianoStudente = await getPianoPagamentiCorsoStudenti(
        username,
        token,
        this.corso.id,
        s.id
      );
      this.costoTotale +=
        pianoStudente != undefined ? parseInt(pianoStudente.costo) : costoCorso;
      this.costoStudente[s.id] =
        pianoStudente != undefined ? parseInt(pianoStudente.costo) : costoCorso;
    }

    for (var i = 0; i < this.studenti.length; i++) {
      var s = this.studenti[i];
      const pianoStudente = await getPianoPagamentiCorsoStudenti(
        username,
        token,
        this.corso.id,
        s.id
      );
      if (!pianoStudente) continue;

      const ratePiano = pianoStudente.rate; // Tutte le rate previste dal piano
      var rate = await getRataStatus(username, token, this.corso.id, s.id); // Stato delle rate
      var pagate = 0;
      var totaleRate = ratePiano.length;

      console.log(
        `[BILLING] Calcolo rate per studente ${s.nome} ${s.cognome}:`,
        {
          ratePiano: ratePiano,
          rateStatus: rate,
          totaleRate: totaleRate,
        }
      );

      // Logica migliorata di confronto delle rate
      for (var r of rate) {
        if (r.status !== "PAGATA") continue;

        // Normalizza l'importo rimuovendo simboli di valuta e spazi
        const importoStatusNormalized = parseFloat(
          String(r.importo)
            .replace(/[€\s]/g, "")
            .replace(",", ".")
        );

        // Cerca una rate corrispondente nel piano
        const rataCorrispondente = ratePiano.find((p) => {
          // Normalizza anche l'importo del piano
          const importoPianoNormalized = parseFloat(
            String(p.importo)
              .replace(/[€\s]/g, "")
              .replace(",", ".")
          );

          const dataMatch = p.data === r.data;
          const importoMatch =
            Math.abs(importoPianoNormalized - importoStatusNormalized) < 0.01;

          console.log(`[BILLING] Confronto rata:`, {
            pianData: p.data,
            statusData: r.data,
            dataMatch,
            pianImporto: p.importo,
            statusImporto: r.importo,
            pianImportoNorm: importoPianoNormalized,
            statusImportoNorm: importoStatusNormalized,
            importoMatch,
          });

          return dataMatch && importoMatch;
        });

        if (rataCorrispondente) {
          pagate++;
          this.totalePagato += parseInt(
            r.importo.toString().replace(/[€\s]/g, "")
          );
          console.log(`[BILLING] Rata pagata trovata: ${pagate}/${totaleRate}`);
        }
      }

      // Assegna il rapporto "pagate/totalRate" allo studente
      this.studenti[i].rate_pagate = `${pagate}/${totaleRate}`;

      console.log(
        `[BILLING] Risultato finale per ${s.nome} ${s.cognome}: ${pagate}/${totaleRate}`
      );
    }

    /*var rate = await getRataStatusAll(username, token);
    rate = rate.filter(r => r.id_corso == this.corso.id && r.status == 'PAGATA');
    for (var r of rate){
      this.totalePagato += parseInt(r.importo);
    }*/

    this.pianoRate = await getPianoPagamentiCorso(
      username,
      token,
      this.corso.id
    );

    // Funzione helper per estrarre solo il nome del file dal percorso
    const extractFileName = (filePath) => {
      if (!filePath) return null;
      // Rimuove il percorso e mantiene solo il nome del file
      return filePath.split("/").pop();
    };

    this.setState({
      costo: "0",
      uploaded: this.pdfPagamentiStatus.caricato,
      pdfFileName: this.pdfPagamentiStatus.data
        ? extractFileName(
            this.pdfPagamentiStatus.data.filename ||
              this.pdfPagamentiStatus.data.nome_file
          )
        : null,
    });
  }

  async componentDidMount() {
    await this.reload();

    // Aggiunge listener per aggiornare quando la finestra torna in focus
    this.handleWindowFocus = () => {
      console.log("[BILLING] Finestra in focus, ricarico i dati...");
      this.reload();
    };

    window.addEventListener("focus", this.handleWindowFocus);
  }

  componentWillUnmount() {
    // Rimuove il listener quando il componente viene smontato
    if (this.handleWindowFocus) {
      window.removeEventListener("focus", this.handleWindowFocus);
    }
  }

  async eliminaPdf() {
    if (window.confirm("Sei sicuro di voler eliminare il pdf?") == false)
      return;
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    try {
      await deletePdfPagamenti(username, token, this.corso.id);

      alert("Pdf eliminato");

      await this.reload();
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const cookies = new Cookies();
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    var headCells = [
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      { id: "mail", numeric: true, disablePadding: false, label: "Mail" },
      {
        id: "piano",
        numeric: true,
        disablePadding: false,
        label: "Piano rate",
      },
      {
        id: "rate_pagate",
        numeric: true,
        disablePadding: false,
        label: "Rate pagate",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["nome", "cognome", "mail", "rate_pagate"];

    if (this.corso == undefined) return <div></div>;

    return (
      <div id={Math.random()}>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <div style={{ marginBottom: 20 }}>
            <PageTitle
              title={"Piano rateale " + this.corso.name}
              button={this.state.uploaded ? "ELIMINA PDF" : "CARICA PDF"}
              onClick={() => {
                if (this.state.uploaded) {
                  this.eliminaPdf();
                } else {
                  this.setState({ uploadPdfShow: true });
                }
              }}
            />
            <div style={{ display: "flex", gap: "10px", marginTop: 10 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  window.location.href = "/#/app/editCorso";
                }}
              >
                Modifica Corso
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  window.location.href = "/#/app/schedule";
                }}
              >
                Calendario
              </Button>
            </div>
          </div>

          {this.state.uploaded && this.state.pdfFileName && (
            <div
              style={{
                marginBottom: "20px",
                padding: "10px",
                backgroundColor: "#f5f5f5",
                borderRadius: "5px",
                border: "1px solid #ddd",
              }}
            >
              <strong>File caricato:</strong> {this.state.pdfFileName}
            </div>
          )}

          {this.state.uploadPdfShow && (
            <UploadPdfPagamenti
              corsoId={currentCourse}
              noTitle={true}
              show={this.state.uploadPdfShow}
              onClose={async () => {
                this.setState({ uploadPdfShow: false });
                await this.reload();
              }}
            />
          )}

          <GestioneRateWidget
            piano={this.pianoRate}
            custom={false}
            isStudent={false}
            corso={this.corso}
            onSalva={async (costo, rate) => {
              var json = {
                costo: costo,
                rate: rate,
              };
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await addPianoPagamentiCorso(
                username,
                token,
                this.corso.id,
                JSON.stringify(json)
              );
              alert("Salvataggio effettuato");
            }}
          />

          <div>
            Importo pagato: {this.totalePagato} -- Importo da pagare:{" "}
            {this.costoTotale - this.totalePagato}
          </div>

          {this.studenti && (
            <Table
              type={"billing"}
              students={true}
              currentCourse={currentCourse}
              addPerson={false}
              removePerson={false}
              headCells={headCells}
              searchCols={this.searchCols}
              calendar={false}
              excel={false}
              rows={this.studenti}
              onEventClick={(row) => {
                cookies.set("currentStudent", row, { path: "/" });
                window.location.href = "/#/app/billing/editStudente";
              }}
            />
          )}

          <GestioneRateCorsoWidget
            piano={this.pianoRate}
            custom={false}
            isStudent={false}
            corso={this.corso}
            onSalva={async (costo, rate) => {
              var json = {
                costo: costo,
                rate: rate,
              };
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await addPianoPagamentiCorso(
                username,
                token,
                this.corso.id,
                JSON.stringify(json)
              );
              alert("Salvataggio effettuato");
            }}
          />
          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </div>
    );
  }
}
